import { DashboardLayoutCustomer } from "../../components/dashboard-layout-customer";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";

import { Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, Typography, Paper } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { t } from "i18next";
import { GetNameChoose } from "../../funcUtils";

function SetXoSo() {
    const [list30, setList30] = useState();
    const [bet, setBet] = useState(null);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [second, setSecond] = useState(0);
    const [minute, setMinute] = useState(2);
    const [start, setStart] = useState(false);
    const [dulieunhap, setDulieunhap] = useState(new Date());
    const [update, setUpdate] = useState(0);
    const [current, setCurrent] = useState(null);
    const date = new Date();
    const currentMinute = date.getMinutes();
    const currentSecond = date.getSeconds();

    function formatDateTimeFull(dateStr) {
        if (!dateStr) return "";
        const m = new Date(dateStr);
        if (isNaN(m.getTime())) return "";
        return (
            ("0" + m.getDate()).slice(-2) + "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) + "/" +
            m.getFullYear() + " " +
            ("0" + m.getHours()).slice(-2) + ":" +
            ("0" + m.getMinutes()).slice(-2) + ":" +
            ("0" + m.getSeconds()).slice(-2)
        );
    }

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/xs120s/getadmin`).then((res) => {
            if (res.data?.data?.[0]) {
                setBet(res.data.data[0]);
                setDulieunhap(new Date(res.data.data[0].createdAt));
                setStart(true);
            }
        });
        axios.get(`${process.env.REACT_APP_API_URL}/xs120s/list30bet`).then((res) => {
            setList30(res.data.data);
        });
        axios.get(`${process.env.REACT_APP_API_URL}/xs120s/getcurrent`).then((res) => {
            setCurrent(res.data.data);
        });
    }, []);

    useEffect(() => {
        const timer = setInterval(() => {
            if (Math.floor(120 - (new Date() - dulieunhap) / 1000) < 0) {
                axios.get(`${process.env.REACT_APP_API_URL}/xs120s/getadmin`).then((res) => {
                    if (res.data?.data?.[0]) {
                        setBet(res.data.data[0]);
                        setDulieunhap(new Date(res.data.data[0].createdAt));
                    }
                });
                axios.get(`${process.env.REACT_APP_API_URL}/xs120s/list30bet`).then((res) => {
                    setList30(res.data.data);
                });
                axios.get(`${process.env.REACT_APP_API_URL}/xs120s/getcurrent`).then((res) => {
                    setCurrent(res.data.data);
                });
            }
        }, 500);
        return () => clearInterval(timer);
    }, [dulieunhap]);

    useEffect(() => {
        let curTime_second = Math.floor(120 - (date - dulieunhap) / 1000);
        if (currentMinute === dulieunhap.getMinutes() && currentSecond === dulieunhap.getSeconds()) {
            setStart(true);
            setSecond(second - 1);
        } else if (curTime_second < 120 && curTime_second >= 0) {
            setSecond(curTime_second % 60);
            setMinute((curTime_second - (curTime_second % 60)) / 60);
            setStart(true);
        } else {
            setTimeout(() => setUpdate(update + 1), 500);
        }
    }, [update, dulieunhap]);

    useEffect(() => {
        let curTime_second = Math.floor(120 - (date - dulieunhap) / 1000);
        let myTimeout = 0;
        if (start) {
            setSecond(curTime_second % 60);
            setMinute(Math.floor(curTime_second / 60));
            if (curTime_second > 120 || curTime_second <= 0) {
                setStart(false);
                setMinute(2);
                setSecond(0);
            } else {
                myTimeout = setTimeout(() => {
                    setSecond(second - 1);
                    axios.get(`${process.env.REACT_APP_API_URL}/xs120s/getcurrent`).then((res) => {
                        setCurrent(res.data.data);
                    });
                }, 1000);
            }
        }
        return () => clearTimeout(myTimeout);
    }, [second, start, dulieunhap]);

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayoutCustomer>
                <Box component="main" sx={{ flexGrow: 1, py: 1 }}>
                    <Container maxWidth={false}>
                        <Typography variant="h4" sx={{ mb: 3, textAlign: 'center', fontWeight: 'bold', color: '#121828' }}>
                            THEO DÕI XỔ SỐ 120S
                        </Typography>

                        <Paper elevation={2} sx={{ p: 2, textAlign: 'center', mb: 4, bgcolor: '#f8f9fa' }}>
                            {bet ? (
                                <Typography variant="h6">
                                    {t('session')} <b style={{ color: '#1976d2' }}>#{bet.id_bet}</b>
                                </Typography>
                            ) : (
                                <Typography>{t('waiting')}</Typography>
                            )}
                            <Typography sx={{ color: "red", fontSize: '40px', fontWeight: 'bold', fontFamily: 'monospace' }}>
                                0{minute} : {second < 10 ? "0" : ""}{second}
                            </Typography>
                        </Paper>

                        <Paper sx={{ mb: 4, overflow: 'hidden' }}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ bgcolor: '#eee' }}>
                                        <TableCell style={{ fontWeight: 'bold' }}>ID</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>{t('username')}</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>{t('selected')}</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>{t('money')}</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Thời gian cược</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {current && current.length > 0 ? (
                                        current.map((item, idx) => (
                                            <TableRow key={idx} hover>
                                                <TableCell>{item?.user?.iduser}</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold', color: '#1976d2' }}>{item?.user?.username}</TableCell>
                                                <TableCell sx={{ color: "#d32f2f", fontWeight: "bold" }}>
                                                    {GetNameChoose(item.state, item.type)}
                                                </TableCell>
                                                <TableCell sx={{ color: "#2e7d32", fontWeight: "bold" }}>
                                                    {item.money.toLocaleString("vi-VN")}
                                                </TableCell>
                                                <TableCell>{formatDateTimeFull(item.createdAt)}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={5} align="center" sx={{ py: 3, color: '#999' }}>{t('no_player')}</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </Paper>

                    </Container>
                </Box>
            </DashboardLayoutCustomer>
        </ThemeProvider>
    );
}

export default SetXoSo;